import React from 'react';
import { SpinnyBall, Verbs } from './UIElements';

import { COLORS } from '@lib/constants';

type Props = {
  color?: string;
  height?: number;
  verbs?: string[];
  ballStyles?: string;
};

const AnimateFootball = ({
  color = COLORS.primary2,
  height = 300,
  verbs = [],
  ballStyles = ''
}: Props) => {
  return (
    <div className="flex flex-col gap-4" data-testid="loading-football">
      <SpinnyBall color={color} height={height} className={ballStyles} />
      <Verbs verbs={verbs} />
    </div>
  );
};

export default AnimateFootball;
